import React from "react";

/**
 *
 * @param showCancel
 * @param showSubmit
 * @param onCancel
 * @param onSubmit
 * @param cancelText
 * @param submitText
 * @param isSubmitting
 * @param cancelClass
 * @param submitClass
 * @returns {JSX.Element}
 * @constructor
 */

/** Usage Examples
 * Show both buttons
 * <ButtonGroup
 *   showCancel={true}
 *   showSubmit={true}
 *   onCancel={() => setQuoteModal(false)}
 *   onSubmit={handleSubmit}
 *   submitText="Preview Quotation"
 * />
 *
 * Only Submit Button
 *
 * <ButtonGroup
 *   showSubmit={true}
 *   showCancel={false}
 *   onSubmit={handleSubmit}
 *   submitText="Save"
 * />
 *
 * Only Cancel Button
 *
 * <ButtonGroup
 *   showSubmit={false}
 *   showCancel={true}
 *   onCancel={() => setQuoteModal(false)}
 *   cancelText="Go Back"
 * />
 *
 * Another ButtonGroup Example
 * <ButtonGroup
 *   onCancel={() => setShowModal(false)}
 *   onSubmit={formik.handleSubmit}
 *   isSubmitting={formik.isSubmitting}
 *   cancelText="Back"
 *   submitText="Save"
 *   cancelBtnProps={{ id: 'cancel-btn', title: 'Cancel the form' }}
 *   submitBtnProps={{ id: 'submit-btn' }}
 * />
 */

const ButtonGroup = ({
    showCancel = true,
    showSubmit = true,
    onCancel,
    onSubmit,
    cancelText = 'Cancel',
    submitText = 'Submit',
    isSubmitting = false,
    cancelClass = 'btn border_btn',
    submitClass = 'btn btn-primary ms-2',
    cancelBtnProps = {},
    submitBtnProps = {},
    /** 🔑 NEW: externally control the submit button state */
    disabled = false
}) => {
    return (
        <div className="btn_wrap">
            {showCancel && (
                <button
                    type="button"
                    className={cancelClass}
                    onClick={onCancel}
                    {...cancelBtnProps}
                >
                    {cancelText}
                </button>
            )}
            {showSubmit && (
                <button
                    {...submitBtnProps}
                    type="button"
                    className={submitClass}
                    onClick={onSubmit}
                    disabled={isSubmitting || disabled}   
                >
                    {submitText}
                </button>
            )}
        </div>
    );
};

export default ButtonGroup;

